declare let __webpack_public_path__: string

/**
 * Check the current script path VS the public path interpolated during Webpack build.
 * If they are different, it means that this script is loaded by a CDN and Webpack has no knowledge of it during the build step.
 * In this case, we need to setup the public path dynamically, so that Webpack dynamic chunks are loaded from the CDN as well.
 * The assets are moved to the CDN after the Webpack build stage and the build stage is shared between staging and production,
 * so we need to rely on the special '__webpack_public_path__' variable to set the public path dynamically.
 * @param currentPath - The current script path
 * @param publicPath - The public path interpolated during Webpack build
 * @returns The effective public path to use
 */
export function setupDynamicChunkPublicPath(
  currentPath: string | null,
  publicPath: string
): string | null {
  if (!publicPath || !currentPath) {
    return null
  }

  try {
    const currentPathUrl = new URL(currentPath)

    if (currentPath !== publicPath) {
      const effectivePath = new URL(publicPath, currentPathUrl.origin)

      return effectivePath.toString()
    }
  } catch (e) {
    console.error(e)
  }

  return null
}

const currentScript = document?.currentScript as HTMLScriptElement

const effectivePath = setupDynamicChunkPublicPath(
  currentScript.src,
  process.env.PUBLIC_PATH as string
)

if (effectivePath) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  __webpack_public_path__ = effectivePath
}
